export const Header = () => {
    const header = document.querySelector('.main-header');
    if (!header) return;
    
    const updateHeaderHeight = () => {
        const headerHeight = header.offsetHeight;
        document.body.style.setProperty(
            '--header-height',
            `${headerHeight}px`,
        );
    }
    updateHeaderHeight();

    window.addEventListener('resize', updateHeaderHeight);

    const isTransparentVariant = header.classList.contains('transparent-variant');
    if (!isTransparentVariant) return;

    if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
        header.classList.remove('transparent');
    }

    window.addEventListener('scroll', () => {
        if (window.scrollY > 250) {
            header.classList.remove('transparent');
        } else {
            header.classList.add('transparent');
        }
    })
}

export default Header;